import React from 'react';
import { View, Text, StyleSheet } from 'react-native';
import BookingsList from '../../../Occupancy/LocationOccupancyDashboard/components/BookingsList';
import Style from '../../../../constants/Style';
import Colors from '../../../../constants/Colors';

const BookingsWidget = () => <>
  <View style={[Style.row, styles.sectionHeader]}>
    <Text style={styles.title}>{'Bookings'}</Text>
  </View>
  <BookingsList itemStyle={{ height: null }} />
</>;

const styles = StyleSheet.create({
  sectionHeader: {
    marginBottom: 17,
  },
  details: {
    fontSize: 12,
    lineHeight: 18,
    fontFamily: 'Roboto_400Regular',
    color: Colors.light.hereworksBlue500,
    marginEnd: 6,
  },
  title: {
    flex: 1,
    fontSize: 14,
    lineHeight: 20,
    fontFamily: 'Poppins_500Medium',
    color: Colors.light.hereworksBlack500,
  },
});

export default BookingsWidget;
